import { useState } from "react";
import { CiDollar } from "react-icons/ci";
import { MdOutlineCallToAction } from "react-icons/md";
import { LuShip } from "react-icons/lu";
import { LuCircleDollarSign } from "react-icons/lu";
import { TbStack } from "react-icons/tb";
import { IoCheckmarkCircle } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";
import { BsFiletypePdf } from "react-icons/bs";
import { GoDownload } from "react-icons/go";
import { RxBox } from "react-icons/rx";
import { MdOutlinePending } from "react-icons/md";
import { RiEyeLine } from "@remixicon/react";
// import FilterDrawer from "../utils/FilterDrawer";
import SearchIcon from "@mui/icons-material/Search";
// import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
// import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
import { Link } from "react-router-dom";
import { IoCreateOutline } from "react-icons/io5";
import { RxUpdate } from "react-icons/rx";
import { MdOutlineCancel } from "react-icons/md";

import {
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Box,
} from "@mui/material";
import { RiSortDesc } from "react-icons/ri";
// import { Link } from "react-router-dom";

export default function Orders() {
	const [searchTerm, setSearchTerm] = useState("");
	const [sortBy, setSortBy] = useState("");

	const [age, setAge] = useState("");

	const handleChange = (event) => {
		setAge(event.target.value);
	};

	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value);
	};

	const handleSortChange = (e) => {
		setSortBy(e.target.value);
	};

	const searchPlaceholder = (
		<p>
			{" "}
			<SearchIcon sx={{ display: "inline" }} /> search
		</p>
	);

	const recentOrders = [
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2001",
		},
		{ product: "chrome", status: "pending", eta: "------", id: "#2001" },
		{
			product: "Lead concentrate",
			status: "in transit",
			eta: "28 May 2025",
			id: "#2002",
		},
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2003",
		},
		{
			product: "iron ore",
			status: "confirmed",
			eta: "15 June 2025",
			id: "#2004",
		},
	];

	const recentTransactions = [
		{
			amount: "$30,000",
			status: "completed",
			date: "15 June 2025",
			id: "#2001",
		},
		{ amount: "$30,000", status: "pending", date: "------", id: "------" },
		{ amount: "$30,000", status: "pending", date: "28 May ", id: "#2002" },
		{
			amount: "$30,000",
			status: "completed",
			date: "15 June 2025",
			id: "#2003",
		},
		{
			amount: "$30,000",
			status: "pending",
			date: "15 June 2025",
			id: "#2004",
		},
	];

	const billingHistory = [
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 1,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 2,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 3,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 4,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 5,
		},
		{
			title: "Miners Pack",
			date: "Dec 2022",
			status: "paid",
			amount: "USD $10,000",
			id: 6,
		},
	];

	const content = (
		<section className="  min-h-screen  w-[95%] pb-[1rem] mx-auto   flex flex-col   justify-around items-center  gap-[2rem]">
			{/* dashboard overview section */}
			<section className=" w-full    md:w-[95%]  flex flex-col   justify-around items-end    gap-[2rem]">
				<div className=" w-full  text-left pl-[1rem]  ">
					<h2 className="text-[1.2rem]  font-bold  capitalize">
						Orders Overview
					</h2>
					<p className="text-gray-500">Manage shipments in one place</p>
				</div>

				<div className=" w-[95%] md:w-[98%] mx-auto lg:mx-0  md:mr-auto   flex  sm:flex-row flex-col justify-center   md:justify-start items-center  gap-[1rem]  ">
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<Link
							to="/dctdashboard/admin/create-shipment"
							className="bg-white     py-[0.3rem]   px-[0.4rem]    inline-block  text-black  rounded-md  p-[0.2rem]  border-2  border-gray-600 ">
							{" "}
							<IoCreateOutline className="text-[1.4rem] inline-block  border-2 border-green-600   rounded-[0.2rem] p-[0.2rem] mr-[0.3rem]  " />{" "}
							<span className="capitalize  font-medium   ">
								Create Shipment
							</span>
						</Link>
						<p className="text-[1.8rem]  font-bold">
							24{" "}
							<sub className="text-gray-500  text-[0.8rem]">
								Available shipments
							</sub>
						</p>
					</div>
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<p className="bg-white       py-[0.3rem]   px-[0.4rem]  text-black  rounded-md  p-[0.2rem]   border-2  border-gray-600  ">
							{" "}
							<RxUpdate className="text-[1.4rem] inline-block  border-2 border-yellow-600   rounded-[0.2rem] p-[0.2rem] mr-[0.3rem] " />{" "}
							<span className="capitalize  font-medium">Update Shipment </span>
						</p>
						<p className="text-[1.8rem]  font-bold">
							12{" "}
							<sub className="text-gray-500  text-[0.8rem]">
								Updated shipments
							</sub>{" "}
						</p>
					</div>
					<div className="  min-h-[7rem]  w-[98%]  px-[1rem] flex  flex-col  justify-center  gap-[0.5rem]    items-start shadow-sm shadow-gray-200  border-2   border-gray-300    rounded-lg">
						<p className="bg-white    py-[0.3rem]   px-[0.4rem]  text-black  rounded-md  p-[0.2rem]   border-2  border-gray-600  ">
							{" "}
							<MdOutlineCancel className="text-[1.8rem] inline-block  border-2 border-red-600 rounded-[0.2rem] p-[0.2rem] mr-[0.3rem] " />{" "}
							<span className="capitalize  font-medium">Cancel Shipment</span>
						</p>
						<p className="text-[1.8rem]  font-bold">
							3{" "}
							<sub className="text-gray-500  text-[0.8rem]">
								Canceled shipments
							</sub>{" "}
						</p>
					</div>
				</div>
			</section>

			{/* miner pack & recent documents section */}

			{/* <section className="w-[95%]  mx-auto flex  flex-col  md:flex-row   justify-center  items-center   gap-[1rem]">
				<div>
					<div className="min-w-full   min-h-full  pb-[1rem]  rounded-lg  border-2 border-gray-300">
						<p className=" w-full   text-green-500   min-h-[4rem]  flex  justify-between  px-[1rem] items-center   border-b-2 border-b-gray-300">
							<span>
								{" "}
								<TbStack className="inline-block  mr-[0.7rem]" />{" "}
								<span>Miners Pack</span>
							</span>{" "}
							<IoCheckmarkCircle />
						</p>

						<div className="min-h-[11rem]  px-[1rem]   flex  flex-col   justify-center  items-start  gap-[1rem] ">
							<div className="   mx-auto flex flex-col  md:flex-row  justify-center  items-start gap-[1rem]">
								{" "}
								<p>
									<span className="text-[2rem]  font-bold">$300</span>
									<sub className="text-gray-500  inline">per month</sub>{" "}
								</p>
								<span className="text-gray-500  text-[0.9rem]">
									{" "}
									Unlimited seller profiles, document downloads, premium filters{" "}
								</span>
							</div>
							<p className="border-2  px-[0.5rem]   w-fit   border-gray-300  rounded-md">
								{" "}
								<GoDotFill className="inline-block  text-green-500" /> Active
							</p>
						</div>
						<div className="flex   flex-col   justify-start items-start  lg:items-end  lg:gap-[0.9rem] lg:flex-row-reverse   px-[0.8rem] ">
							<div className="text-[0.9rem]   flex   flex-row gap-[0.5rem] md:flex-col  justify-start items-center">
								<p className="text-gray-500  ">Renewal Date</p>{" "}
								<p className="font-bold text-black">25 June 2025</p>
							</div>
							<div className="flex  justify-between  gap-[0.4rem]  items-center">
								<button className="bg-green-500 block  font-thin  text-[0.9rem]  rounded-md py-[0.2rem] px-[0.5rem]  text-white">
									Renew subscription
								</button>
								<p className="border-2  border-gray-300  font-thin    text-[0.9rem]   rounded-md  py-[0.2rem]   px-[1rem]">
									View benefits
								</p>
							</div>
						</div>
					</div>
				</div>

				
				<div className="    min-h-[8rem]   w-full  flex  flex-col rounded-lg justify-center items-center   border-2  border-gray-300   ">
					<p className="font-bold  my-[1rem] ">Recent Documents</p>
					<hr className="w-[90%]" />
					<div className=" w-full   pb-[1rem]  px-[0.5rem]  flex flex-col  justify-center items-center gap-[1rem]">
						<div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<BsFiletypePdf className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"}</p>{" "}
							<GoDownload className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div>
						<div className=" min-w-[90%]  px-[1rem]  min-h-[3rem]     flex  justify-around  items-center gap-[0.5rem]  border-2  border-gray-300  rounded-lg   ">
							<BsFiletypePdf className="inline-block  text-red-500" />{" "}
							<p>Purchase Order {"PO_10329.pdf"} </p>{" "}
							<GoDownload className=" text-[1.6rem]  p-[0.3rem] rounded-full border-2  border-gray-300   inline-block" />
						</div>
					</div>
				</div>
			</section> */}

			{/* recent transactions, recent orders and billing history */}

			<section className="w-[95%] min-h-full  flex  flex-col   md:flex-row   gap-[1rem] justify-center items-center ">
				{/* recent transactions & orders */}
				<div className=" w-full   min-h-full     flex flex-col   justify-center items-center gap-[1.5rem]">
					{/* recent orders */}
					<div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
						{/* <div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
							<h5 className="font-bold">Recent Orders </h5>{" "}
							<button className="border-2 border-gray-300 rounded-md  px-[1rem]  py-[0.2rem]  ">
								view all
							</button>
						</div> */}
						{/* search and filters for big screens*/}

						<div className="hidden  md:flex  justify-center  items-center   ">
							<div className="mr-auto">
								{/* Search Input */}
								<TextField
									label={searchPlaceholder}
									variant="outlined"
									value={searchTerm}
									onChange={handleSearchChange}
									size="small"
									// InputProps={{
									// 	startAdornment: (
									// 		<InputAdornment position="start" sx={{ display: "inline" }}>
									// 			<SearchIcon />
									// 		</InputAdornment>
									// 	),
									// }}
								/>
							</div>

							<FormControl
								sx={{
									m: 1,
									minWidth: 150,
									// Target the input outline to set border width
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											borderWidth: 1, // Set your desired border width here
										},
									},
								}}
								size="small">
								<InputLabel
									id="demo-select-small-label"
									sx={{ minWidth: "10rem" }}>
									All statuses
								</InputLabel>
								<Select
									labelId="demo-select-small-label"
									id="demo-select-small"
									value={age}
									input={<OutlinedInput label="All statuses" />}
									label="status"
									onChange={handleChange}>
									<MenuItem value="">
										<em>None</em>
									</MenuItem>
									<MenuItem value={10}>Confirmed</MenuItem>
									<MenuItem value={20}>Pending</MenuItem>
									<MenuItem value={30}>In transit</MenuItem>
								</Select>
							</FormControl>
							<FormControl
								sx={{
									m: 1,
									minWidth: 150,
									// Target the input outline to set border width
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											borderWidth: 1, // Set your desired border width here
										},
									},
								}}
								size="small">
								<InputLabel
									id="demo-select-small-label"
									sx={{ minWidth: "10rem" }}>
									All Minerals
								</InputLabel>
								<Select
									labelId="demo-select-small-label"
									id="demo-select-small"
									value={age}
									input={<OutlinedInput label="All Minerals" />}
									label="status"
									onChange={handleChange}>
									<MenuItem value="">
										<em>None</em>
									</MenuItem>
									<MenuItem value={10}>manganese</MenuItem>
									<MenuItem value={20}>Copper</MenuItem>
									<MenuItem value={30}>Fe</MenuItem>
								</Select>
							</FormControl>
							<FormControl
								sx={{
									m: 1,
									minWidth: 150,
									// Target the input outline to set border width
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											borderWidth: 1, // Set your desired border width here
										},
									},
								}}
								size="small">
								<InputLabel
									id="demo-select-small-label"
									sx={{ minWidth: "10rem" }}>
									All Sellers
								</InputLabel>
								<Select
									labelId="demo-select-small-label"
									id="demo-select-small"
									value={age}
									input={<OutlinedInput label="All Minerals" />}
									label="status"
									onChange={handleChange}>
									<MenuItem value="">
										<em>None</em>
									</MenuItem>
									<MenuItem value={10}>New Sellers</MenuItem>
									<MenuItem value={20}>Old Sellers </MenuItem>
									<MenuItem value={30}>Verified Sellers</MenuItem>
								</Select>
							</FormControl>
							{/* <FormHelperText>With label + helper text</FormHelperText> */}
							{/* <FormControl sx={{ m: 1, minWidth: 120 }}>
								<Select
									value={age}
									onChange={handleChange}
									displayEmpty
									inputProps={{ "aria-label": "Without label" }}>
									<MenuItem value="">
										<em>None</em>
									</MenuItem>
									<MenuItem value={10}>Ten</MenuItem>
									<MenuItem value={20}>Twenty</MenuItem>
									<MenuItem value={30}>Thirty</MenuItem>
								</Select>
								<FormHelperText>Without label</FormHelperText>
							</FormControl> */}
						</div>

						{/* search  and filters for small screens */}
						<div className="md:hidden ">
							<Box display="flex" alignItems="center" gap={0.5} padding={1}>
								{/* Search Input */}
								<TextField
									label={searchPlaceholder}
									variant="outlined"
									value={searchTerm}
									onChange={handleSearchChange}
									size="small"
									// InputProps={{
									// 	startAdornment: (
									// 		<InputAdornment position="start" sx={{ display: "inline" }}>
									// 			<SearchIcon />
									// 		</InputAdornment>
									// 	),
									// }}
								/>
								{/* filter drawer */}
								{/* <FilterDrawer /> */}

								{/* Sort By Dropdown with Icon placeholder */}
								<FormControl
									variant="outlined"
									size="small"
									sx={{ minWidth: { sm: 30, md: 100 } }}
									// style={{  }}
								>
									<InputLabel
										id="sort-by-label"
										sx={{
											fontSize: "0.8rem",
											display: { sm: "hidden", lg: "block" },
										}}>
										<span
											className={`${
												sortBy === "" ? "hidden" : "inline-block"
											} lg:inline-block`}>
											{" "}
											Sort By
										</span>
									</InputLabel>
									<Select
										labelId="sort-by-label"
										value={sortBy}
										onChange={handleSortChange}
										label="Sort By"
										// Add an icon at the start of the select input
										IconComponent={RiSortDesc}>
										<MenuItem value="">
											<em>None</em>
										</MenuItem>
										<MenuItem value="priceLowToHigh">
											<span>Price:</span>{" "}
											<span className="text-gray-500">Low to High</span>
										</MenuItem>
										<MenuItem value="priceHighToLow">
											<span>Price:</span>{" "}
											<span className="text-gray-500">High to Low</span>
										</MenuItem>
										<MenuItem value="complianceLowToHigh">
											<span>Compliance:</span>{" "}
											<span className="text-gray-500">Low to High</span>
										</MenuItem>
										<MenuItem value="complianceHighToLow">
											<span>Compliance:</span>{" "}
											<span className="text-gray-500">High to Low</span>
										</MenuItem>
									</Select>
								</FormControl>
							</Box>
						</div>
						<ul className=" w-full  text-[0.9rem]  ">
							<li className="pl-[0.3rem] py-[0.4rem] bg-gray-300 grid        grid-cols-3  md:grid-cols-5">
								<p className="hidden  md:flex justify-start items-center  ">
									<RxBox /> ID
								</p>
								<p>product</p>
								<p className="hidden  md:block">Status</p>
								<p className="bg-green-500 min-w-fit  ">ETA</p>
							</li>

							{recentOrders.map((data) => (
								<li
									key={data.id}
									className=" min-h-[4rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  grid  grid-cols-3  md:grid-cols-5">
									<p className="hidden  md:block">{data.id}</p>
									<p className="">
										{data.product}

										<span className="block md:hidden text-gray-500  ">
											{data.id}
										</span>
									</p>
									<p className="hidden  md:block">
										<span
											className={` max-w-fit px-[0.1rem]  rounded-md  block  ${
												data.status === "confirmed"
													? "bg-green-300  text-green-700"
													: data.status === "pending"
													? "bg-yellow-300 text-yellow-700"
													: "text-blue-500"
											}`}>
											{data.status === "confirmed" ? (
												<IoCheckmarkCircle className="inline-block" />
											) : data.status === "pending" ? (
												<MdOutlinePending className="inline-block" />
											) : (
												<LuShip className="inline-block" />
											)}{" "}
											{data.status}
										</span>

										{/* {data.status} */}
									</p>
									<p>
										{data.eta}

										<span
											className={` max-w-fit px-[0.2rem] md:hidden rounded-md  block  ${
												data.status === "confirmed"
													? "bg-green-300  text-green-700"
													: data.status === "pending"
													? "bg-yellow-300 text-yellow-700"
													: "text-blue-500"
											}`}>
											{data.status === "confirmed" ? (
												<IoCheckmarkCircle className="inline-block" />
											) : data.status === "pending" ? (
												<MdOutlinePending className="inline-block" />
											) : (
												<LuShip className="inline-block" />
											)}{" "}
											{data.status}
										</span>
									</p>
									<Link
										to="/godashboard/user/view-order"
										className="  max-w-[1rem] ml-auto  mr-[1rem]   grid place-content-center">
										<RiEyeLine size={17} className="inline-block" />
									</Link>
									{/* <hr className="w-[95%]  mx-auto  bg-gray-500" /> */}
									{/* <p>{data.status}</p> */}
								</li>
							))}
						</ul>
					</div>
					{/* recent transactions */}
					<div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
						<div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
							<h5 className="font-bold">Recent Transactions </h5>{" "}
							<button className="border-2 border-gray-300 rounded-md  px-[0.5rem]  py-[0.2rem]  ">
								view all
							</button>
						</div>
						<ul className=" w-full  text-[0.9rem]  ">
							<li className="pl-[0.3rem] py-[0.4rem] bg-gray-300 grid grid-cols-2  md:grid-cols-4">
								<p className="hidden  md:flex justify-start items-center  ">
									<RxBox /> ID
								</p>
								<p>Date</p>
								<p>Amount</p>
								<p className="hidden  md:block">Status</p>
							</li>

							{recentTransactions.map((data) => (
								<li
									key={data.id}
									className=" min-h-[4rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  grid  grid-cols-2  md:grid-cols-4">
									<p className="hidden  md:block">{data.id}</p>
									<p className="">
										{data.date}

										<span className="block md:hidden text-gray-500  ">
											{data.id}
										</span>
									</p>
									<p className="hidden  md:block">
										<span
											className={` max-w-fit px-[0.2rem]  rounded-md  block  ${
												data.status === "completed"
													? "bg-green-300  text-green-700"
													: "bg-yellow-300 text-yellow-700"
											}`}>
											{/* {data.status === "confirmed" ? (
                                                <IoCheckmarkCircle className="inline-block" />
                                            ) : data.status === "pending" ? (
                                                <MdOutlinePending className="inline-block" />
                                            ) : (
                                                <LuShip className="inline-block" />
                                            )}{" "} */}
											{data.status}
										</span>

										{/* {data.status} */}
									</p>
									<p>
										{data.amount}

										<span
											className={` max-w-fit px-[0.2rem] md:hidden rounded-md  block  ${
												data.status === "completed"
													? "bg-green-300  text-green-700"
													: "bg-yellow-300 text-yellow-700"
											}`}>
											{/* {data.status === "confirmed" ? (
                                                <IoCheckmarkCircle className="inline-block" />
                                            ) : data.status === "pending" ? (
                                                <MdOutlinePending className="inline-block" />
                                            ) : (
                                                <LuShip className="inline-block" />
                                            )}{" "} */}
											{data.status}
										</span>
									</p>

									{/* <hr className="w-[95%]  mx-auto  bg-gray-500" /> */}
									{/* <p>{data.status}</p> */}
								</li>
							))}
						</ul>
					</div>
				</div>
				{/* billing history */}
				{/* <div className="w-full p-[0.5rem] min-h-full  border-2  border-gray-300   rounded-md">
					<div className="flex  justify-start items-center gap-[3rem]  my-[0.5rem]">
						<h5 className="font-bold">Billing History </h5>{" "}
						<button className="border-2 border-gray-300 rounded-md  px-[0.5rem]  py-[0.2rem]  ">
							view all
						</button>
					</div>
					<ul className=" w-full  text-[0.9rem]  ">
						{billingHistory.map((data) => (
							<li
								key={data.id}
								className=" min-h-[6rem]    place-content-center   text-[0.8rem]  border-b-2  border-b-gray-300  gap-[1.5rem]  grid  grid-cols-2  ">
								<p className="">
									{data.title}-{data.date}
									<span className="block  text-gray-500   bg-green-100  px-[0.5rem] max-w-fit rounded-md ">
										<GoDotFill className="  inline-block text-green-500" />
										{data.status}
									</span>
								</p>
								<p className="hidden  md:block">
									<span
										className={` max-w-fit px-[0.2rem]  rounded-md  block  `}>
										{data.amount}
									</span>
								</p>
								<p className="md:hidden">{data.amount}</p>
							</li>
						))}
					</ul>
				</div> */}
			</section>
		</section>
	);

	return content;
}
